import { useState } from 'react';
import { findAutorizacionesAmbulatorias } from '../../../services/Busquedas/Autorizaciones';

export const useBuscarAutorizaciones = () => {
  const [messageStatus, setMessageStatus] = useState({
    status: '',
    message: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [autorizaciones, setAutorizaciones] = useState(null);

  const buscarAutorizaciones = async (filtro) => {
    setIsLoading(true);
    const response = await findAutorizacionesAmbulatorias(filtro).catch((error) => {
      setAutorizaciones(null);
    });

    if (!response || response.length < 1) {
      setMessageStatus({
        status: 'info',
        message: 'Busqueda sin resultados, intente con otros parámetros.',
      });
      setAutorizaciones(null);
    } else if (response) {
      setAutorizaciones(response);
      setMessageStatus({
        status: 'success',
        message: 'Autorizaciones encontradas exitosamente.',
      });
    }

    setIsLoading(false);
  };

  const cleanBusqueda = () => {
    setAutorizaciones(null);
    setMessageStatus({ status: '', message: '' });
    setIsLoading(false);
  };

  return {
    autorizaciones,
    messageStatus,
    isLoading,
    buscarAutorizaciones,
    cleanBusqueda,
  };
};
